export const FLAXIL_API = 'https://api.flaxil.com';
export const FLAXIL_API_DEV = 'https://api.axildev-flaxil.com';
export const AXIL_API = 'https://api.axil.ai';
export const AXIL_API_DEV = 'https://dev-api.axil.ai';
